import {
  SectionGroupDetail,
  SectionGroupDetailShort
} from "./SectionGroupDetail";

export class SectionGroup {
  key!: string;
  icon!: string;
  order!: number;
  name!: string;
  itemsByStep!: boolean;
  formTemplates?: SectionGroupDetail[] | SectionGroupDetailShort[];
  sessions?: SectionGroupDetail[] | string[];
  progress?: number;
  cups?: string;

  constructor() {
    this.name = "";
    this.icon = "";
    this.formTemplates = new Array<SectionGroupDetail>();
    this.sessions = new Array<SectionGroupDetail>();
  }
}
